export function normalizeOAuthRedirect(): void {
  const url = new URL(window.location.href);

  const oauthParams = [
    'code',
    'state',
    'error',
    'id_token',
    'access_token'
  ];

  const hasOAuthParams = oauthParams.some(p => url.searchParams.has(p));

  if (hasOAuthParams && !url.hash) {
    const newUrl =
      url.origin +
      url.pathname +
      '#/?' +
      url.searchParams.toString();

    window.history.replaceState({}, document.title, newUrl);
  }
}